import { ActivePopup } from 'store/activePopups';
import { axiosInstance } from './axiosBaseInstance';

export const disableActivePopup = async (activePopupId: number): Promise<void> =>
  axiosInstance.post(`/popups/${activePopupId}/disable`);

export const getActivePopups = async (): Promise<ActivePopup[] | undefined> => axiosInstance.get('/popups');
